import React from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register GSAP plugins
if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

const Clients = () => {
  return (
    <section className="py-24 bg-white text-center px-6">
      <h3 className="text-3xl font-bold text-[#0b9949] mb-6">Our Clients</h3>
      <p className="text-gray-700 max-w-2xl mx-auto text-lg mb-10">
        We proudly collaborate with industry leaders, government organizations, and educational institutions — building safer and greener environments together.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-center">
        {[
          "https://upload.wikimedia.org/wikipedia/commons/a/ab/Logo_Tata_Group.svg",
          "https://upload.wikimedia.org/wikipedia/commons/7/79/Siemens_AG_logo.svg",
          "https://upload.wikimedia.org/wikipedia/commons/4/4f/Shell_logo.svg",
          "https://upload.wikimedia.org/wikipedia/commons/f/fa/Unilever.svg",
        ].map((logo, i) => (
          <div
            key={i}
            className="p-6 bg-[#f6fdf9] rounded-xl shadow-md hover:shadow-xl transition-all hover:scale-105 flex items-center justify-center"
          >
            <img
              src={logo}
              alt="Client Logo"
              className="h-16 object-contain grayscale hover:grayscale-0 transition"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Clients;
